import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'
import { animated } from '@react-spring/web'
import { IconButton } from '../UI'
import Slider from '../Slider'
import PreviewCompatibleImage from '../PreviewCompatibleImg'
import Dialog from '../Dialog'

const SlickWrapper = styled.div`
  z-index: 1;
  position: relative;
  overflow: hidden;
  max-width: 100vw;
  .slick-slider {
    background-color: ${(props) => props.theme.colors.lightergrey};
  }
  .slick-track {
    align-items: center;
    display: flex;
    max-height: 100vh;
    background-color: ${(props) => props.theme.colors.lightergrey};
  }
  &.full-screen {
    .slick-list {
      min-height: 100vh;
    }
    .slick-track {
      min-height: 100vh;
    }
  }
`

const FullSliderImg = styled(PreviewCompatibleImage)`
  max-height: 100vh;
`

export function decoratSlider(slickList) {
  if (!slickList) return
  slickList.setAttribute('tabindex', 0)
  slickList.setAttribute(
    'aria-label',
    'Image gallery slider (use arrow keys to navigate)'
  )
}

const FullScreenSlider = ({
  animatedStyle,
  onClose,
  images,
  handleBeforeChange,
  currentImageIndex,
}) => {
  const ref = useRef(null)

  const focusSlider = () => {
    const slickList = ref.current.innerSlider.list
    decoratSlider(slickList)
    slickList.focus()
  }

  useEffect(() => {
    ref && ref.current && focusSlider()
  }, [])

  return (
    <Dialog
      as={animated.div}
      onClose={onClose}
      style={{
        ...animatedStyle,
        position: 'fixed',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        backgroundColor: '#fafafa',
        zIndex: 3,
      }}
    >
      {({ close }) => (
        <SlickWrapper className="full-screen">
          <Slider
            ref={ref}
            nextArrowProps={{
              boxShadow: '',
            }}
            prevArrowProps={{
              boxShadow: '',
            }}
            settings={{
              adaptiveHeight: true,
              initialSlide: currentImageIndex,
              slidesToShow: 1,
              beforeChange: function (prev, current) {
                handleBeforeChange(current)
              },
              infinite: true,
              arrows: true,
            }}
          >
            {images &&
              images.map((image) => (
                <FullSliderImg
                  showLoading
                  key={image.id}
                  objectFit={'contain'}
                  backgroundColor={'#dadada'}
                  styles={{
                    display: 'block',
                  }}
                  imgStyle={{ objectFit: 'contain', verticalAlign: 'middle' }}
                  image={image.fluid}
                />
              ))}
          </Slider>
          <IconButton
            round
            onClick={close}
            bg="lightergrey"
            variant="none"
            color="grey"
            name={'times'}
            tabIndex={0}
            aria-label="Close slider"
            style={{
              zIndex: 1,
              position: 'absolute',
              top: 12.5,
              right: 12.5,
            }}
          />
        </SlickWrapper>
      )}
    </Dialog>
  )
}

export default FullScreenSlider
